import {  collaboratorsLocale as collaboratorsEn } from './en/collaborators.locale';
import { collaboratorsLocale as collaboratorsVi } from './vi/collaborators.locale';
import { collaboratorsLocale as collaboratorsRu } from './ru/collaborators.locale';
import { collaboratorsLocale as collaboratorsKo } from './ko/collaborators.locale';
import { collaboratorsLocale as collaboratorsJp } from './jp/collaborators.locale';
import { collaboratorsLocale as collaboratorsZh } from './zh/collaborators.locale';
export const collaboratorsLocale = {
    en: {
        collaborators: collaboratorsEn,
    },
    vi: {
        collaborators: collaboratorsVi,
    },
    jp: {
        collaborators: collaboratorsJp,
    },
    ru: {
        collaborators: collaboratorsRu,
    },
    zh: {
        collaborators: collaboratorsZh,
    },
    ko: {
        collaborators: collaboratorsKo,
    },
};
